import { apiHolder, apis } from 'api';
import { getMailContentText } from '../../../util';
import { thunkHelperFactory } from '@web-common/utils/redux_utils';
const mailApis = apiHolder.api.requireLogicalApi(apis.mailApiImpl);
const ReducerName = 'MailReducer';
const Thunks = {};
const ReducersList = [];
const thunkHelper = thunkHelperFactory(ReducerName, Thunks, ReducersList);
thunkHelper({
    name: 'doGetCurrentMailLang',
    request: async (params, thunkAPI) => {
        var _a, _b, _c, _d;
        const { rejectWithValue } = thunkAPI;
        const { mid } = params;
        const state = thunkAPI.getState().mailReducer;
        const { mailEntities } = state;
        const currentMailContent = mailEntities[mid];
        try {
            const mailContent = (_b = (_a = currentMailContent.entry) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.content;
            let result = (_d = (_c = currentMailContent === null || currentMailContent === void 0 ? void 0 : currentMailContent.entry) === null || _c === void 0 ? void 0 : _c.langListMap) === null || _d === void 0 ? void 0 : _d.originLang;
            if (result) {
                return {
                    lang: result,
                    mid,
                };
            }
            if (mailContent) {
                const _content = getMailContentText({ content: mailContent, removeSign: true, removeUnSubText: true });
                if (_content) {
                    const data = await mailApis.detectMailContentLang(mid, _content);
                    if (data && data.detected) {
                        return {
                            lang: data.lang,
                            mid,
                        };
                    }
                }
            }
            return {
                lang: 'zh-CHS',
                mid,
            };
        }
        catch (err) {
            return rejectWithValue(err);
        }
    },
    fulfilled: (state, action) => {
        const { mid, lang } = action.payload || {};
        const { mailEntities } = state;
        const currentMailContent = mailEntities[mid];
        const langListMap = currentMailContent.entry.langListMap || {};
        if (!langListMap.originLang) {
            langListMap.originLang = lang;
            currentMailContent.entry.langListMap = langListMap;
        }
    },
    rejected: (state, action) => {
        var _a;
        const error = ((_a = action === null || action === void 0 ? void 0 : action.error) === null || _a === void 0 ? void 0 : _a.message) || action.payload || action.error;
        console.warn('getMailListRequestParams', error);
    },
});
export const mailStateManageThunks = Thunks;
export const mailStateManageReducersList = ReducersList;
